import { routerMiddleware, routerReducer } from 'react-router-redux';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { reducer as formReducer } from 'redux-form';
import { thunk } from 'redux-thunk';
import modals from '../components/Modals/modalsReducer';
import { restoreState } from '../middleware/localStorage';
import logger from '../middleware/logger';
import currentTheme from '../redux/reducers/manageThemeReducer';
import isAuthorized from '../redux/reducers/authorizeReducer';
import view from '../redux/reducers/viewReducer';
import windowFilter from '../redux/reducers/filterReducer';
import dataReload from '../redux/reducers/dataReloadReducer';
import windowQuery from '../components/WindowQuery/WindowQueryReducer';
import windowEdit from '../components/views/WindowEditView/WindowEditReducer';
import HistoryService from '../services/HistoryService';
import oidcReducer from '../redux/reducers/oidcReducer';

const router = routerMiddleware(HistoryService);

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });
const store = createStore(
    combineReducers({
        isAuthorized,
        modals,
        form: formReducer,
        routing: routerReducer,
        currentTheme,
        view,
        windowFilter,
        windowQuery,
	    windowEdit,
        dataReload,
        oidc: oidcReducer
    }),
    restoreState(),
    composeEnhancers(applyMiddleware(thunk, logger, router))
)
// loadUser(store, userManager);

global.store = store;

export default store;
export const dispatch = store.dispatch;